import React from 'react'
import style from './PageInicio.module.css'
import Presentacion from './presentacion/Presentacion'
import Productos from './productos/Productos'
import Carrusel from '../carrusel/Carrusel'
//import Elearning from './elearning/Elearning'
//import { useTranslation } from 'react-i18next'
import ServiciosComp from './servicios/Servicios'

// eslint-disable-next-line no-unused-vars
const PageInicio = ({ t }) => {

  return (
    <div className={style.inicio}>
      <Presentacion />
      <Productos />
      <Carrusel />
      {/*<Elearning />*/}
      <ServiciosComp/>
    </div>
  )
}

export default PageInicio